import { canvasStageStyles } from '@constants/canvas/general';
import { styled } from '@mui/material/styles';

export const FrozenCanvasStyled = styled('div')({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  backgroundColor: canvasStageStyles.backgroundColor,
  zIndex: 11,
});
